import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function Header({ rightExtra }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="header">
      <div className="header-left">
        <Link to="/" className="brand">
          <h1>PauOtomotiv</h1>
        </Link>
        <span className="subtitle">GPS Arac Takip</span>
        {user && (
          <nav className="header-nav">
            <NavLink to="/" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
              Harita
            </NavLink>
            {user.role === 'admin' && (
              <NavLink to="/admin" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
                Yonetim
              </NavLink>
            )}
          </nav>
        )}
      </div>
      <div className="header-right">
        {rightExtra}
        {user && (
          <div className="user-info">
            <span className="username">{user.username}</span>
            <span className={`role-badge role-${user.role}`}>{user.role}</span>
            <button className="logout-btn" onClick={handleLogout}>Cikis</button>
          </div>
        )}
      </div>
    </header>
  );
}
